import React from 'react'
import ResponsiveImage, { ImageParams } from 'components/Common/ResponsiveImage'
import styled from 'styled-components'
import { isHotelPackage } from 'lib/offer/offerTypes'

export const AccommodationIndividualRoomTileImageContainer = styled.div``

const IMAGE_PROPS: ImageParams = {
  mobileWidth: '80px',
  mobileAspectRatio: '80:76',
  tabletWidth: '120px',
  tabletAspectRatio: '80:76',
  desktopWidth: '400px',
  desktopAspectRatio: 'auto',
  quality: 'good',
}

interface Props {
  roomPackage?: App.HotelPackage | App.BedbankPackage
}

function AccommodationIndividualRoomTileImage(props: Props) {
  const {
    roomPackage,
  } = props

  const room = isHotelPackage(roomPackage) ? roomPackage.roomType : roomPackage

  const imageId = room?.images[0]?.id

  if (!imageId) {
    return null
  }

  return <AccommodationIndividualRoomTileImageContainer>
    <ResponsiveImage
      {...IMAGE_PROPS}
      id={imageId}
      alt={room.images[0].title}
    />
  </AccommodationIndividualRoomTileImageContainer>
}

export default AccommodationIndividualRoomTileImage
